import { Epic, ofType } from 'redux-observable';
import { from, of } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';
import { GET_TERM_REPORT_CONFIGS_REQUEST } from '../../../actions/types';
import { getTermReportConfigs } from '../../../actions';

export const getTermReportConfigsEpic: Epic = (action$, state$, { api }) =>
  action$.pipe(
    ofType(GET_TERM_REPORT_CONFIGS_REQUEST),
    switchMap((action) => {
      return from(
        api.reportsCenterService.getTermReportConfigs(action.payload).pipe(
          mergeMap((response) =>
            of(
              getTermReportConfigs.success(
                response?.termReportConfigurationsList ?? []
              )
            )
          ),
          catchError((err) => of(getTermReportConfigs.failure(err)))
        )
      );
    })
  );

export default getTermReportConfigsEpic;
